import useCalendar from "../context/useCalendar";
import { EditProfileText } from "./StyledComponents";
import { useTranslation } from "react-i18next";

interface Props {
    profileId: number;
}

const EditProfile = ({ profileId }: Props) => {
    const { inputCallbacks } = useCalendar();
    const { t } = useTranslation();

    const handleClick = () => {
        inputCallbacks.onModifyProfile(profileId);
    };

    return (
        <EditProfileText onClick={handleClick}>
            {t("edit_profile")}
        </EditProfileText>
    );
};

export default EditProfile;
